// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XCp1","top":"styles_top__3meqT","left":"styles_left__2br-v","description":"styles_description__2rXet"};